
export const numberFormatter = new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});

const group = numberFormatter.format(1111).replace(/\d/g, '');
const decimal = numberFormatter.format(1.1).replace(/\d/g, '');

numberFormatter.unformat = (val) => {
    if (!isNaN(val)) {
        return val;
    }
    var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
    reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
    return Number.isNaN(reversedVal) ? 0 : reversedVal;
}